// useFetchCarousels.js
import { useEffect, useState } from "react";
import { getAllCarousels } from "../utils/carouselService"; // Make sure to import from the correct location

const useFetchCarousels = () => {
  const [reload, setReload] = useState(false);
  const [carousels, setCarousels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reloadCarousels = () => setReload((prev) => !prev);

  useEffect(() => {
    const fetchCarousels = async () => {
      try {
        const result = await getAllCarousels();
        if (result && result.success) {
          const fetchedCarousels = result.data ?? [];
          console.log("Fetched carousels:", fetchedCarousels);
          setCarousels(Array.isArray(fetchedCarousels) ? fetchedCarousels : []);
        } else {
          setCarousels([]);
          setError(result?.error || new Error("Failed to fetch carousels"));
        }
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchCarousels();
  }, [reload]);

  return { carousels, loading, error, reloadCarousels };
};

export default useFetchCarousels;
